//@ts-nocheck
import { getConfig } from "../config/config";
import { checkIsEmpty, uintToJson, getDepthToken } from "../helpers";
import { SOCKET_EVENT } from "./constant";
const { APP_BASE_20DEPTH_WS_URL } = getConfig();
let feedSocketRef;
let localclientCode = localStorage.getItem("ClientCode");
const subscriberList = [];
//const heartBeatSubscriberList: SubscriptionMethod[] = [];
const scripMap = {};
const publishMessage = (eventType, data) => {
    if (feedSocketRef != undefined) {
        // console.log("This is a tribute GD", eventType, data);
        feedSocketRef.postMessage({ eventType: eventType, data: data });
    }
};
export const initDepthSocket = async () => {
    if (feedSocketRef == undefined) {
        let token = await getDepthToken(localStorage.DepthTokenResponseTv);
        feedSocketRef = new Worker(new URL("depth.worker.ts", import.meta.url));
        if (window.Worker) {
            let access_token = token.access_token;
            const swarajWsurl = `${APP_BASE_20DEPTH_WS_URL}ws?access_token=${access_token}`;
            feedSocketRef.onmessage = (e) => {
                try {
                    const eventData = uintToJson(e.data);
                    handleAndDispatchMessage(eventData.eventType, eventData.data);
                }
                catch (error) {
                    console.error(error);
                }
                // requestAnimationFrame(() => {
                // });
            };
            setTimeout(() => {
                publishMessage("CONNECT_SOCKET", {
                    wsUrl: swarajWsurl,
                    clientCode: localclientCode,
                });
            }, 1000);
        }
    }
    else {
        onFocusChange(true);
    }
};
export const subscribeToDepthData = (subscriptionMethod, subscriberName, isDomPanel, callBackMethod) => {
    let subsData = subscriberList.find((singleSubData) => {
        if (subscriptionMethod.Method === singleSubData.Method) {
            return singleSubData;
        }
    });
    if (subsData) {
        subsData.MarketFeedData.push(...subscriptionMethod.MarketFeedData);
        // scripMap
        subsData.MarketFeedData = arrayUnique(subsData.MarketFeedData);
    }
    else {
        subsData = subscriptionMethod;
        subscriberList.push(subscriptionMethod);
    }
    subscriptionMethod.MarketFeedData.forEach((singleElement) => {
        if (callBackMethod) {
            const isNew = addSingleScripSubscriber(subscriberName, singleElement, callBackMethod, subscriptionMethod.Method);
        }
    });
    if (isDomPanel) {
        setTimeout(() => {
            publishMessage("SUBSCRIBE", {
                ...subscriptionMethod,
                subscriberName,
            });
        }, 1000);
    }
    else {
        publishMessage("SUBSCRIBE", {
            ...subscriptionMethod,
            subscriberName,
        });
    }
};
const addSingleScripSubscriber = (subscriberName, marketFeedSingleElement, callBackMethod, methodName) => {
    let scripObj = scripMap[marketFeedSingleElement.Exch +
        marketFeedSingleElement.ExchType +
        marketFeedSingleElement.ScripCode];
    if (scripObj) {
        const subsObj = scripObj.subscribers.find((singleElement) => {
            const isAlreadySubscribed = singleElement.componentName == subscriberName;
            return isAlreadySubscribed;
        });
        if (subsObj) {
            const alreadySubscribedMethod = subsObj.method.find((singleElement) => {
                return singleElement == methodName;
            });
            //Just updating it in case there was rerender.Ideally this component itself will not call again
            subsObj.callback = callBackMethod;
            if (checkIsEmpty(alreadySubscribedMethod)) {
                subsObj.method.push(methodName);
                return true;
            }
            else {
                return false;
            }
        }
        else {
            scripObj.subscribers.push({
                method: [methodName],
                callback: callBackMethod,
                componentName: subscriberName,
            });
            return true;
        }
    }
    else {
        scripObj = {
            subscribers: [
                {
                    method: [methodName],
                    callback: callBackMethod,
                    componentName: subscriberName,
                },
            ],
            data: undefined,
            lastUpdateTime: undefined,
        };
        scripMap[marketFeedSingleElement.Exch +
            marketFeedSingleElement.ExchType +
            marketFeedSingleElement.ScripCode] = scripObj;
        return true;
    }
};
export const unsubscribeDataBySubscriberM = (subscriberName, methodName) => {
    publishMessage(SOCKET_EVENT.UNSUBSCRIBE_BY_SUBSCRIBER, {
        subscriberName,
        methodName,
    });
    Object.keys(scripMap).forEach((singleScripKey) => {
        unSubscribeDataByScripKey(subscriberName, singleScripKey, methodName);
    });
};
export const unsubscribeDataByScrip = (subscriberName, marketFeedSingleElement, methodName) => {
    publishMessage(SOCKET_EVENT.UNSUBSCRIBE, {
        subscriberName,
        scripData: marketFeedSingleElement,
        methodName,
    });
    unSubscribeDataByScripKey(subscriberName, getScripKey(marketFeedSingleElement), methodName);
};
const unSubscribeDataByScripKey = (subscriberName, singleScripKey, methodName) => {
    const scripObj = scripMap[singleScripKey];
    if (scripObj) {
        if (checkIsEmpty(methodName)) {
            const newSubList = scripObj.subscribers.filter((singleElement) => {
                return singleElement.componentName != subscriberName;
            });
            if (newSubList.length > 0) {
                scripObj.subscribers = newSubList;
            }
            else {
                delete scripMap[singleScripKey];
            }
        }
        else {
            const newSubList = scripObj.subscribers.filter((singleElement) => {
                return singleElement.componentName == subscriberName;
            });
            if (newSubList.length > 0) {
                const newMethodList = newSubList[0].method.filter((singleMethod) => {
                    return singleMethod != methodName;
                });
                if (newMethodList.length > 0) {
                    newSubList[0].method = newMethodList;
                }
                else {
                    //Recursive call as we need to remove the subscriber itself
                    unSubscribeDataByScripKey(subscriberName, singleScripKey);
                }
            }
        }
    }
};
const arrayUnique = (array) => {
    const a = array.concat();
    for (let i = 0; i < a.length; ++i) {
        for (let j = i + 1; j < a.length; ++j) {
            if (a[i].ScripCode == a[j].ScripCode && a[i].Exch == a[j].Exch)
                a.splice(j--, 1);
        }
    }
    return a;
};
const getScripKey = (marketFeedSingleElement) => {
    return (marketFeedSingleElement.Exch +
        marketFeedSingleElement.ExchType +
        marketFeedSingleElement.ScripCode);
};
//-----------Listening and Dispatching message section-------------------
const handleAndDispatchMessage = (methodName, message) => {
    if (message) {
        if (message.PacketIdentifier && (message === null || message === void 0 ? void 0 : message.PacketIdentifier) == "G") {
            message.Exch = message.Exch ? message.Exch : "N";
            message.ExchType = message.ExchType ? message.ExchType : "D";
        }
        else if (message.Exch == undefined) {
            return;
        }
        // if (Date.now() - lastSyncTime > 3000) {
        //   resetLastSyncTime("DATA_STARTED_COMING");
        //   // store.dispatch(openSocketNotification(false));
        // }
        const key = message.Exch + message.ExchType + message.Token + "";
        const scripObj = scripMap[key];
        if (scripObj) {
            scripObj.lastUpdateTime = new Date();
            // let dataObj: {
            //   openInterest?: SocketResponseSyncObject;
            //   marketDepthData?: SocketResponseSyncObject;
            //   marketFeedData?: SocketResponseSyncObject;
            //   greekFeedData?: SocketResponseSyncObject;
            // };
            // if (scripObj?.data) {
            //   dataObj = scripObj.data;
            // } else {
            //   dataObj = {};
            //   scripObj.data = dataObj;
            // }
            // let selectedSocketResponseSyncObject: SocketResponseSyncObject;
            // let methodName = "";
            // if (!selectedSocketResponseSyncObject.syncTime) {
            //   dispatchSingleMessage(scripObj, selectedSocketResponseSyncObject);
            // }
            const isDataSubscribed = checkAnddispatchDataUsingCallBack(scripObj, message, methodName);
            // if (isDataSubscribed) {
            //   //Commented this to remove throttling completely
            //   // if (REACT_APP_ENV == "staging" || REACT_APP_ENV == "development") {
            //   //   dispatchSingleMessage(scripObj, selectedSocketResponseSyncObject);
            //   // } else
            //   if (!selectedSocketResponseSyncObject.syncTime) {
            //     dispatchSingleMessage(scripObj, message, methodName);
            //   }
            //   // } else {
            //   //   // unsubscribeSpecificMethodFromSocket(
            //   //   //   message.Exch,
            //   //   //   message.ExchType,
            //   //   //   message.Token,
            //   //   //   methodName
            //   //   // );x
            //   // }
            // }
            // else if (isSocketConnected) {
            //   unsubscribeFromSocket(message.Exch, message.ExchType, message.Token);
            // }
        }
    }
};
const checkAnddispatchDataUsingCallBack = (scripObj, message, methodName) => {
    let isDataSubscribed = false;
    scripObj.subscribers.forEach((singleSubscriber) => {
        let localSubsribed = false;
        singleSubscriber.method.forEach((singleMethod) => {
            if (singleMethod == methodName) {
                isDataSubscribed = true;
                localSubsribed = true;
            }
        });
        if (localSubsribed && singleSubscriber.callback) {
            singleSubscriber.callback(message);
        }
    });
    return isDataSubscribed;
};
// const dispatchSingleMessage = (
//   scripObj: SocketScripObject,
//   message: any,
//   methodName: string
// ): void => {
//   console.log("Dispatch");
//   // if (message?.Token == 35003) {
//   //   console.log("This is a tribute nifty fut", message);
//   // }
//   // if (methodName == SOCKET_EVENT.GREEKS_DATA) {
//   //   store.dispatch(setGreeksMsg(message));
//   // } else {
//   store.dispatch(setMessage(message));
//   // }
// };
export const onFocusChange = (isWindowFocused) => {
    // if (isSocketConnected) {
    //   return;
    // }
    publishMessage(SOCKET_EVENT.IS_WINDOW_FOCUSED, isWindowFocused);
};
//--- unused methods for now-----------------
export const heartBeatData = (subscriptionMethod, subscriberName, callbackMethod) => {
    return subscribeToData(subscriptionMethod, subscriberName, callbackMethod);
};
// const subscribeToData = (
//   subscriptionMethod: SubscriptionMethod,
//   subscriberName: string,
//   callBackMethod: any
// ): void => {
//   if (subscriptionMethod.Method == SOCKET_SUBSCRIPTION_METHODS.MARKET_FEED_V3) {
//     marketFeedSubMap[subscriberName] = callBackMethod;
//   } else if (
//     subscriptionMethod.Method == SOCKET_SUBSCRIPTION_METHODS.BASE_GREEKS
//   ) {
//     greeksSubMap[subscriberName] = callBackMethod;
//   } else if (
//     subscriptionMethod.Method ==
//     SOCKET_SUBSCRIPTION_METHODS.SCRIPT_INFO_FOR_FUTURE
//   ) {
//     oiSubMap[subscriberName] = callBackMethod;
//   } else if (
//     subscriptionMethod.Method == SOCKET_SUBSCRIPTION_METHODS.DEPTH_SERVICE
//   ) {
//     depthSubMap[subscriberName] = callBackMethod;
//   }
//   publishMessage(SOCKET_EVENT.SUBSCRIBE, subscriptionMethod);
// };
// const unSubscribeToData = (
//   subscriptionMethod: SubscriptionMethod,
//   subscriberName: string
// ): void => {
//   if (subscriptionMethod.Method == SOCKET_SUBSCRIPTION_METHODS.MARKET_FEED_V3) {
//     delete marketFeedSubMap[subscriberName];
//   } else if (
//     subscriptionMethod.Method == SOCKET_SUBSCRIPTION_METHODS.BASE_GREEKS
//   ) {
//     delete greeksSubMap[subscriberName];
//   } else if (
//     subscriptionMethod.Method ==
//     SOCKET_SUBSCRIPTION_METHODS.SCRIPT_INFO_FOR_FUTURE
//   ) {
//     delete oiSubMap[subscriberName];
//   } else if (
//     subscriptionMethod.Method == SOCKET_SUBSCRIPTION_METHODS.DEPTH_SERVICE
//   ) {
//     delete depthSubMap[subscriberName];
//   }
//   publishMessage(SOCKET_EVENT.SUBSCRIBE, subscriptionMethod);
// };
